import React, { useState, useRef, useEffect } from "react";
import { useLanguage } from "@/i18n";
import { KeenIcon } from "@/components";
import { I18N_LANGUAGES } from "@/i18n/config";
import clsx from "clsx";

const LanguageSwitcher = () => {
  const { currentLanguage, changeLanguage, isRTL } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!currentLanguage) {
    return null;
  }

  const handleLanguage = (lang) => {
    changeLanguage(lang);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Button trigger */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center rounded-md shadow-md hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors md:p-0 md:text-xs text-xs md:h-auto bg-white"
      >
        <div className="flex items-center gap-1.5 rounded-md border border-gray-300 text-gray-600 font-medium shrink-0 md:text-xs p-1.5 text-xs ">
          {currentLanguage.label}
          <img
            src={currentLanguage.flag}
            className="inline-block md:w-3.5 md:h-3.5 w-6 h-6 rounded-full"
            alt={currentLanguage.label}
          />
        </div>
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div
          className={clsx(
            "absolute left-1/2 transform -translate-x-1/2 mt-2 bg-transparent rounded-lg shadow-lg py-1 z-10 border border-gray-200 w-40",
            isRTL() ? "left-0" : "right-0"
          )}
        >
          {I18N_LANGUAGES.map((lang, index) => (
            <button
              key={index}
              onClick={() => handleLanguage(lang)}
              className={clsx(
                "flex items-center gap-3 w-full px-2 py-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors",
                currentLanguage.code === lang.code
                  ? "text-primary bg-gray-50 dark:bg-gray-750"
                  : "text-gray-700 dark:text-gray-300"
              )}
            >
              <div className="flex-shrink-0">
                <img
                  src={lang.flag}
                  className="inline-block w-4 h-4 rounded-full"
                  alt={lang.label}
                />
              </div>
              <span className="flex-grow text-left">{lang.label}</span>
              {currentLanguage.code === lang.code && (
                <KeenIcon
                  icon="check-circle"
                  style="solid"
                  className="text-success text-base flex-shrink-0"
                />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
